/**
 * "People" tab on the side of the VR user menu: opens the in-headset list of
 * everyone in the room (mute / block / report each). Placed as a sibling of
 * VRUserMenuSurface in VRViewer's menu group, just right of the panel.
 */
import React, { useState } from 'react';
import { Text } from '@react-three/drei';
import { vrColors as colors, noRaycast, Surface } from '../VR/vrUi';
import { useWorldStore } from '../../stores/worldStore';
import { openPeopleList, roomPeople } from './openSafety';

export default function VRPeopleTab({ x = .445, y = .085 }: { x?: number; y?: number }) {
  const [hover, setHover] = useState(false);
  // Re-render when people come and go, for the count.
  useWorldStore((s) => s.onlinePlayers);
  const n = roomPeople().length;
  return <group position={[x, y, .008]} name="vr-menu-people"
    onPointerOver={(e) => { e.stopPropagation(); setHover(true); }} onPointerOut={() => setHover(false)}
    onClick={(e) => { e.stopPropagation(); openPeopleList({ vr: true }); }}>
    <Surface width={.104} height={.11} color={colors.border} z={-.002} r={.016} />
    <Surface width={.098} height={.104} color={hover ? colors.hover : colors.card} r={.014} />
    <Text raycast={noRaycast} position={[0, .02, .003]} fontSize={.026} color={colors.teal}>{String(n)}</Text>
    <Text raycast={noRaycast} position={[0, -.022, .003]} fontSize={.0165} color={colors.text}>People</Text>
  </group>;
}
